import { Col, Input, Row } from "reactstrap";

import Select from "react-select";

import { useEffect, useState } from "react";
import {
  useGetStatesQuery,
  useGetDistrictByStateQuery,
  useGetBlockByDistrictQuery,
} from "services/locationApiSlice";
import swal from "sweetalert";
import "react-loading-skeleton/dist/skeleton.css";

const StateDistrict = ({
  onLocationChange,
  state_id,
  district_id,
  block_id,
  stateName,
  districtName,
  blockName,
  setBlockList,
  blockList,noBlock,setStateName,setDistrictName,setStateId,setDistrictId
}) => {
  //   const [state_id, setStateId] = useState("");
  //   const [districtId, setDistrictId] = useState("");
  //   const [blockId, setBlockId] = useState("");
  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(state_id);
  const { data: dataBlock } = useGetBlockByDistrictQuery(district_id);

  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  //   const [stateName, setStateName] = useState("");
  //   const [districtName, setDistrictName] = useState("");
  //   const [blockName, setBlockName] = useState("");
  const [loadingStateOptions, setloadingStateOptions] = useState(true);
  const [loadingDistrictOptions, setloadingDistrictOptions] = useState(true);

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 40,
      minHeight: 40,
    }),
  };
  useEffect(() => {
    if (getStates != undefined) {
      setStateList(getStates?.data?.results);
      setloadingStateOptions(false);
    }
  }, [getStates]);
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };
  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };

  const handleLocationChange = (event) => {
    onLocationChange(event);
  };
  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
      setloadingDistrictOptions(false);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock != undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);

  return (
    <>
      <Row className="text-gray mt-2">
        <Col lg="3" className="mb-3 position-relative">
          {!noBlock &&<label className="text-black"> State</label>}
          <Select
            menuPlacement="auto"
            options={handleStateOptions()}
            placeholder={state_id === "" ? "Select State" : stateName}
            value={state_id === "" ? "Select State" : stateName}
            onChange={handleLocationChange}
            styles={customStyles}
            isLoading={loadingStateOptions}
            className="mt-2 "
          />
           {state_id !== "" && (
                              <span
                                className="clear-icon"
                                onClick={() => {
                                  setStateId("");
                                  setStateName("");
                                  setDistrictId("");
                                  setDistrictName("");
                                }}
                                style={{
                                  position: "absolute",
                                  top: "70%",
                                  right: "60px",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "gray",
                                  fontSize: "12px",
                                  zIndex: 1000,
                                }}
                              >
                                ✕
                              </span>
                            )}
        </Col>
        <Col lg="3" className="mb-3 position-relative">
          {!noBlock&&<label className="text-black"> District</label>}
          <Select
            menuPlacement="auto"
            isLoading={loadingDistrictOptions}
            options={handleDistrictOptions()}
            placeholder={districtName == "" ? "Select District" : districtName}
            value={districtName === "" ? "Select District" : districtName}
            onChange={handleLocationChange}
            styles={customStyles}
            className="mt-2"
          />
             {districtName !== "" && (
                              <span
                                className="clear-icon"
                                onClick={() => {
                                  setDistrictId("");
                                  setDistrictName("");
                                }}
                                style={{
                                  position: "absolute",
                                  top: "70%",
                                  right: "60px",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "gray",
                                  fontSize: "12px",
                                  zIndex: 1000,
                                }}
                              >
                                ✕
                              </span>
                            )}
        </Col>
       {!noBlock&& <Col lg="3" className="mb-3">
          <label className="text-black"> Block</label>
          <Select
            menuPlacement="auto"
            options={handleBlockOptions()}
            placeholder={blockName == "" ? "Select Block" : blockName}
            value={blockName === "" ? "Select Block" : blockName}
            onChange={handleLocationChange}
            styles={customStyles}
            className="mt-2"
          />
        </Col>}
      </Row>
    </>
  );
};
export default StateDistrict;
